import { type Context, createContext, useContext } from 'react';

import { ExpandableMenuItemLevelContext } from './expandable-menu-item-level-context';

/**
 * Whether all ancestor menu items of the current menu item are expanded. Used to know if the current menu item is
 * shown within the menu item tree.
 */
export const AreAllAncestorsExpandedContext: Context<boolean | null> = createContext<
	boolean | null
>(null);

/**
 * A context for storing the level value of the ExpandableMenuItem.
 */
export const LevelContext: Context<number> = ExpandableMenuItemLevelContext;

export const useLevel = (): number => useContext(LevelContext);

/**
 * Whether all ancestor menu items of the current menu item are expanded. Used to know if the current menu item is
 * shown within the menu item tree.
 *
 * It works by combining (using &&) all the expansion states of the current menu item's ancestors.
 *
 * Using `true` as the fallback for cases when the menu item does not have ancestors.
 */
export const useAreAllAncestorsExpanded = (): boolean =>
	useContext(AreAllAncestorsExpandedContext) ?? true;
